import { render } from "./MedicationView.vue?vue&type=template&id=2bd5a690"
import script from "./MedicationView.vue?vue&type=script&lang=js"
export * from "./MedicationView.vue?vue&type=script&lang=js"

import "./MedicationView.vue?vue&type=style&index=0&id=2bd5a690&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/MedicationView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2bd5a690"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2bd5a690', __exports__)) {
    console.log('reload')
    api.reload('2bd5a690', __exports__)
  }
  
  module.hot.accept("./MedicationView.vue?vue&type=template&id=2bd5a690", () => {
    console.log('re-render')
    api.rerender('2bd5a690', render)
  })

}


export default __exports__